import { decodeFoodText } from './food-text.js';
import { toCyrillic, toLatin } from './search.js';
/** Query-side alternatives: retain doubles because the source FTS is unmodified.
 * Transliteration is not translation, stemming or fuzzy correction. */
export function foodSearchTerms(query, offTokenizer = false) {
    const words = decodeFoodText(query).toLowerCase().match(/[\p{L}\p{N}]+(?:['’`][\p{L}\p{N}]+)*/gu) ?? [];
    return words.map(raw => {
        const word = raw.replace(/['’`]/g, '');
        const base = [word, toLatin(word), toCyrillic(word), word.replace(/ё/g, 'е')].filter(Boolean);
        // Pragmatic spelling bound: enumerate at most 16 combinations per base token
        // with <=4 е/ё positions. Larger words retain originals, single changes and
        // all-е/all-ё forms; universal spelling combinations are intentionally out of scope.
        const variants = base.flatMap(token => {
            const positions = Array.from(token).flatMap((c, i) => c === 'е' || c === 'ё' ? [i] : []);
            if (positions.length <= 4) {
                let combinations = [token];
                for (const i of positions)
                    combinations = combinations.flatMap(v => [
                        v.slice(0, i) + 'е' + v.slice(i + 1), v.slice(0, i) + 'ё' + v.slice(i + 1)
                    ]);
                return combinations;
            }
            return [token, ...positions.map(i => token.slice(0, i) + (token[i] === 'е' ? 'ё' : 'е') + token.slice(i + 1)),
                token.replace(/ё/g, 'е'), token.replace(/е/g, 'ё')];
        });
        // unicode61 splits apostrophes. A quoted phrase keeps those pieces adjacent;
        // the joined legacy alternative remains available to both catalogs.
        if (offTokenizer && raw !== word)
            variants.push(raw.replace(/['’`]/g, ' '));
        return [...new Set(variants)];
    });
}
/** Whole brand labels stay intact; query alternatives share food search normalization. */
export function foodBrandPrefix(brand, query) {
    const target = foodSearchTerms(brand), terms = foodSearchTerms(query);
    return terms.length > 0 && terms.length <= target.length && terms.every((group, i) => group.some(q => target[i].some(word => word.startsWith(q))));
}
export function foodBrandSuggestions(brands, query, limit = 8) {
    const seen = new Set();
    return brands.map(decodeFoodText).map(s => s.trim()).filter(s => {
        const key = foodSearchTerms(s).map(g => g[0]).join(' ');
        if (!s || s.length > 80 || seen.has(key) || !foodBrandPrefix(s, query))
            return false;
        seen.add(key);
        return true;
    }).sort((a, b) => a.localeCompare(b, 'ru')).slice(0, limit);
}
//# sourceMappingURL=food-search.js.map